import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Footer from "../../layout/Footer";
import * as Yup from "yup";
import axios from "axios";
import { getApiUrl } from "../../../utils/AuthUtils";

const ResetPassword = () => {
  const entityLogo = localStorage.getItem("entity_logo");
  const entityName = localStorage.getItem("entity_name");

  const { token } = useParams(); // token from route param
  const [new_password, setNewPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Yup schema
  const validationSchema = Yup.object().shape({
    new_password: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/\d/, "Password must contain at least one digit")
      .matches(
        /[!@#$%&]/,
        "Password must contain at least one special character from allowed characters !@#$%&"
      )
      .required("New password is required"),
    confirm_password: Yup.string()
      .oneOf(
        [Yup.ref("new_password"), null],
        "Confirm password must match new password"
      )
      .required("Confirm password is required"),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage("");
    setErrorMessage("");

    try {
      // Validate inputs
      await validationSchema.validate(
        { new_password, confirm_password },
        { abortEarly: false }
      );

      setLoading(true);

      // Call API
      const res = await axios.post(`${getApiUrl()}/api/reset-password`, {
        token,
        new_password,
      });

      setMessage(res.data.message || "Password reset successfully");
    } catch (err) {
      if (err.name === "ValidationError") {
        // Yup validation errors
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        setErrors(validationErrors);
      } else if (err.response) {
        // API errors
        setErrorMessage(err.response.data.message || "Something went wrong");
      } else {
        setErrorMessage("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-page">
      <div className="main-wrapper">
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <img src={entityLogo} alt="Entity Logo" />
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                {entityName && (
                  <h2 className="account-title">{entityName}</h2>
                )}
                <h3 className="account-title">Reset Password</h3>
                <p className="account-subtitle">
                  Enter your new password below
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                    <label>New Password</label>
                    <input
                      className="form-control"
                      type="password"
                      value={new_password}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    {errors.new_password && (
                      <small className="text-danger">
                        {errors.new_password}
                      </small>
                    )}
                  </div>

                  <div className="input-block">
                    <label>Confirm Password</label>
                    <input
                      className="form-control"
                      type="password"
                      value={confirm_password}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {errors.confirm_password && (
                      <small className="text-danger">
                        {errors.confirm_password}
                      </small>
                    )}
                  </div>

                  <div className="input-block text-center">
                    <button
                      className="btn btn-primary account-btn"
                      type="submit"
                    >
                      {loading ? "Resetting..." : "Reset Password"}
                    </button>
                  </div>

                  {message && (
                    <div className="alert alert-info mt-3">{message}</div>
                  )}
                  {errorMessage && (
                    <div className="alert alert-danger mt-3">{errorMessage}</div>
                  )}

                  <div className="account-footer">
                    <p>
                      Back to <Link to="/login">Login</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
